export function encode(data) {
    try {
        return JSON.stringify(data)
    } catch(error) {
        return window.btoa(JSON.stringify(data));
    }
  }
  
  export function decode(data) {
      try {
          return JSON.parse(data);
      } catch(error) {
        return JSON.parse(window.atob(data));
      }
  }